import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = { class: "row" };
const _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_toolbar_title = _resolveComponent("q-toolbar-title");
    const _component_q_space = _resolveComponent("q-space");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_toolbar = _resolveComponent("q-toolbar");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    return (_openBlock(), _createBlock(_component_q_dialog, {
        ref: "dialogRef",
        onHide: _ctx.onDialogHide,
        persistent: !_ctx.nonPersistent,
        "data-cy": "prompt-dialog"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_toolbar, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-h6" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["normal-break", {
                                                'text-negative': (_ctx.headerText || '').toLowerCase().includes('warning')
                                            }]),
                                        innerHTML: _ctx.headerText
                                    }, null, 10, _hoisted_1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_q_space),
                            _createVNode(_component_q_btn, {
                                flat: "",
                                round: "",
                                dense: "",
                                icon: "close",
                                onClick: _ctx.onCancelClick
                            }, null, 8, ["onClick"])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_section, { class: "pt-xlg pb-xlg" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("span", {
                                    class: "text-body1 normal-break",
                                    innerHTML: _ctx.text
                                }, null, 8, _hoisted_3)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_card_section, {
                        align: "right",
                        class: "q-pt-none"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                                label: _ctx.cancelBtnLabel,
                                onClick: _ctx.onCancelClick,
                                class: "st-wh-110 text-body1",
                                color: "negative",
                                "data-cy": "prompt-dialog-reject",
                                name: "close"
                            }, null, 8, ["label", "onClick"]),
                            _createVNode(_component_q_btn, {
                                label: _ctx.okBtnLabel,
                                onClick: _ctx.onOKClick,
                                class: "st-wh-110 q-ml-md text-body1",
                                color: "positive",
                                "data-cy": "prompt-dialog-accept",
                                name: "accept"
                            }, null, 8, ["label", "onClick"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["onHide", "persistent"]));
}
